import { subscribeRealTime, unsubscribeRealTime } from '../ws-client';
import { apiUrl, GTFS_SNAPSHOT_PATH, fetchWithSubscriptionKey } from '../api-manager';

const realTimeTrackingSubscription = `
{
    id
    vehicle {
        vehicle {
            id
            label
        }
        trip {
            tripId
            routeId
            startTime
            startDate
            directionId
            .replacementTripId
        }
        timestamp
        position {
            bearing
            latitude
            longitude
        }
        occupancyStatus
        tags
    }
    tripUpdate
}
`;

export const subscribeRealTimeUpdate = ({ onData, onError }) => subscribeRealTime({
    queryString: realTimeTrackingSubscription,
    filters: {
        $or: {
            vehicle: true,
            tripUpdate: true,
        },
    },
    onData,
    onError,
});

export const unsubscribeRealTimeUpdate = () => unsubscribeRealTime();

export const getRealTimeSnapshot = () => {
    const controller = new AbortController();
    return fetchWithSubscriptionKey(apiUrl(`${GTFS_SNAPSHOT_PATH}/vehiclepositions`), {
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
        },
        signal: controller.signal,
    }).then(async (response) => {
        if (response.ok) {
            if (response.status === 204) {
                return response;
            }
            const res = await response.json();
            controller.abort();
            return res;
        }
        return [];
    });
};

export const getTripUpdateRealTimeSnapshot = (tripId) => {
    const controller = new AbortController();
    const baseUrl = apiUrl(`${GTFS_SNAPSHOT_PATH}/tripupdates`);
    const url = !tripId ? baseUrl : `${baseUrl}/${tripId}`;
    return fetchWithSubscriptionKey(url, {
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
        },
        signal: controller.signal,
    }).then(async (response) => {
        if (response.ok) {
            if (response.status === 204) {
                return response;
            }
            const res = await response.json();
            controller.abort();
            return res;
        }
        return [];
    });
};
